import { DtacBase } from "./dtac-base";
import { ExternalReference, EXTERNAL_REFERENCE_TEMPLATE } from "./external-reference";
import { Location, LOCATION_TEMPLATE } from "./location";
import { MovementTimes } from "./movement-times";
import { Person } from "./person";
import { TransportMeans, TRANSPORT_MEANS_TEMPLATE } from "./transport-means";

export interface TransportMovement extends DtacBase {
  transportMeansOperators: Person[];
  transportIdentifier: string;
  modeCode: string;
  departureLocation: Location;
  arrivalLocation: Location;
  movementTimes: MovementTimes[];
  transportMeans: TransportMeans;
  externalReferences: ExternalReference;
};

export const TRANSPORT_MOVEMENT_TEMPLATE: TransportMovement = {
  '@id': '',
  '@type': '',
  transportMeansOperators: [],
  transportIdentifier: '',
  modeCode: '',
  departureLocation: LOCATION_TEMPLATE,
  arrivalLocation: LOCATION_TEMPLATE,
  movementTimes: [],
  transportMeans: TRANSPORT_MEANS_TEMPLATE,
  externalReferences: EXTERNAL_REFERENCE_TEMPLATE
};
